import { useCallback, useEffect, useRef, useState } from 'react';

export enum TIMER_STATUS {
  RUNNING = 'RUNNING',
  STOPPED = 'STOPPED',
}

export type Config = {
  onTimeOver?: () => void;
};

interface TimerData {
  status: TIMER_STATUS;
  timeZone: string;
}

export type ReturnValue = {
  startTimer: (expiresInMs: number, timeZone?: string) => void;
  stopTimer: () => void;
  data: TimerData;
};

export interface State {
  data: TimerData;
  time: number;
}
let time = 0;

export const useTimer = ({ onTimeOver }: Partial<Config> = {}): ReturnValue => {
  const [timerData, setTimerData] = useState<TimerData>({
    status: TIMER_STATUS.STOPPED,
    timeZone: 'America/Sao_Paulo',
  });

  const expiresInRef = useRef(0);

  const startTimer = useCallback((expiresInMs: number, timeZone?: string) => {
    time = 0;
    setTimerData({
      status: TIMER_STATUS.RUNNING,
      timeZone: timeZone || 'America/Sao_Paulo',
    });

    expiresInRef.current = expiresInMs;
  }, []);

  const stopTimer = useCallback(() => {
    time = 0;

    setTimerData((prevState) => {
      return { ...prevState, status: TIMER_STATUS.STOPPED };
    });
  }, []);

  useEffect(() => {
    if (timerData.status === TIMER_STATUS.STOPPED || !timerData.timeZone) return;
    const interval = setInterval(() => {
      const dateOnTimeZone = new Date().toLocaleString('en-US', {
        timeZone: timerData.timeZone,
      });

      time = new Date(dateOnTimeZone).getTime();

      const diffInSeconds =
        time && expiresInRef.current && timerData.status === TIMER_STATUS.RUNNING
          ? Math.floor((expiresInRef.current - time) / 1000)
          : 0;

      if (diffInSeconds <= 1) {
        time = 0;
        setTimerData((prevState) => {
          return { ...prevState, status: TIMER_STATUS.STOPPED };
        });

        // se o timer chegar a zero o interval sera limpado
        clearInterval(interval);
        if (!onTimeOver) return;
        return onTimeOver();
      }
    }, 1000);

    // se o usuario fechar a aplicacao o interval sera limpado
    return () => clearInterval(interval);
  }, [onTimeOver, timerData.status, timerData.timeZone]);

  return { startTimer, stopTimer, data: timerData };
};
